e
<template>
    <section>
        
        <div
            class="birthdate flex gap-2.5 justify-center lg:justify-start flex-wrap flex-col items-center lg:items-end md:flex-row ">
            <div class="flex flex-col p-5  ">
                <div class="flex flex-col gap-0.5" >
                    <label>Name</label>
                    <input v-model="name" type="text" placeholder="Name" class="p-3 rounded-full w-80 h-12 border-2 border-gray-600 w-70">
                </div>
                <div class="flex flex-col gap-0.5">
                    <label>Geburtsdatum</label>
                    <input v-model="date" type="date" class="p-3 rounded-full h-12 border-2 border-gray-600 w-80">
                </div>
            </div>
            <div class="flex flex-col p-5  ">
                <div class="flex flex-col gap-0.5" >
                    <label>Partner</label>
                    <input v-model="name_2" type="text" placeholder="Partner" class="p-3 rounded-full w-80 h-12 border-2 border-gray-600 w-70">
                </div>
                <div class="flex flex-col gap-0.5">
                    <label>Geburtsdatum</label>
                    <input v-model="date_2" type="date" class="p-3 rounded-full h-12 border-2 border-gray-600 w-80">
                </div>
            </div> 
        </div>


        
        <div class="birthdate-item flex flex-col gap-2 mb-4 lg:mb-0">
            <button @click="Calculat"
                    class="border-2 text-gray-900 border-gray-900 px-3 py-3 font-bold rounded-full w-28 block mx-auto h-12 text-bg-900">Berechnen</button>
            </div>
        
        <div class="flex w-full flex-wrap justify-between items-center">

        <div class=" w-full lg:w-1/2 px-5 lg:px-0">
          
            <div  class="container flex flex-col gap-2.5 justify-center items-center ">
                
                <div  class="container mx-auto text-center pb-3 text-xl">
                    <p> {{ name }}<span v-if="age != '' && name!= '' " >,</span> {{ age }} <span v-if="age != ''" >jahre alt</span></p>
                    
                </div> 
        
                <div class="obch w-full relative fade">
                    <img src="https://wordpresstuts.com.br/wp-content/uploads/2024/05/schemalittle.png" class="transimage">
                    <div id="n1" class="trans" style="position:absolute; width:9%; height:9%; left:1.4%; top:44.6%;">
                        
                        <div style="background:#ae309a;border:2px solid #ae309a;  width:100%; height:100%; ">
                            <span >{{ n1
                            }}</span>
                        </div>
                    </div>

                    <div id="n3" class="trans" style="position:absolute; width:9%; height:9%; left:45.5%; top:1.4%;">
                        
                        <div style="border:2px solid #ae309a; background:#ae309a; width:100%; height:100%;  ">
                            <span >{{ n3
                            }}</span>
                        </div>
                    </div>

                    <div id="n5" class="trans" style="position:absolute; width:9%; height:9%; left:89%; top:44.6%;">
                        
                        <div style="border:2px solid #eb4b41; background:#eb4b41; width:100%; height:100%;  ">
                            <span  >{{ n5
                            }}</span>
                        </div>
                    </div>

                    <div id="n7" class="trans" style="position:absolute; width:9%; height:9%; left:45.4%; top:89%;">
                        
                        <div style="border:2px solid #eb4b41; background:#eb4b41; width:100%; height:100%;  ">
                            <span >{{ n7
                            }}</span>
                        </div>
                    </div>

                    <div id="n30" class="trans relative" style="position:absolute; width:9%; height:9%; left:45%; top:45%;">
                        
                        <div style="border:2px solid #ffde68; background:#ffde68; width:100%; height:100%;">
                            <span style=" ">{{
                                n30 }}</span>
                        </div>
                    </div>

                    <div id="n2" class="trans"
                        style="position:absolute; width:9%; height:9%; left:14.5%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n2 }}</span>
                        </div>
                    </div>

                    <div id="n4" class="trans"
                        style="position:absolute; width:9%; height:9%; left:76%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n4 }}</span>
                        </div>
                    </div>

                    <div id="n6" class="trans"
                        style="position:absolute; width:9%; height:9%; left:76%; top:75.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n6 }}</span>
                        </div>
                    </div>

                    <div id="n8" class="trans"
                        style="position:absolute; width:9%; height:9%; left:14.4%; top:75.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n8 }}</span>
                        </div>
                    </div>

                    <div id="n23" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:76.7%; ">
                        
                        <div style="border:2px solid #e98c46;background:#e98c46; width:100%; height:100%; ">
                            <span  >{{ n23
                            }}</span>
                        </div>
                    </div>

                    <div id="n21" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:77%; top:47.4%;  ">
                        
                        <div style="border:2px solid #e98c46; background:#e98c46; width:100%; height:100%; ">
                            <span  >{{ n21
                            }}</span>
                        </div>
                    </div>

                    <div id="n28" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:61%; top:60.5%;  border:2px #000000  solid; background:#F0E4F7;">
                        
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n28 }}</span>
                        </div>
                    </div>

                    <div id="n29" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:55.5%; top:65.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n29 }}</span>
                        </div>
                    </div>

                    <div id="n17" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:18.3%; top:46.8%; ">
                        
                        <div style="border:2px solid #00b8f4; background:#00b8f4; width:100%; height:100%; ">
                            <span  >{{ n17
                            }}</span>
                        </div>
                    </div>

                    <div id="n19" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.4%; top:18%;">
                    
                        <div style="border:2px solid #00b8f4; background:#00b8f4; width:100%; height:100%; ">
                            <span  >{{ n19
                            }}</span>
                        </div>
                    </div>

                    <div id="n15" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:82%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#fff; width:100%; height:100%; ">
                            <span style=" ">{{ n15 }}</span>
                        </div>
                    </div>

                    <div id="n11" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:11.4%; ">
                        
                        <div style="border:2px solid #0067d2; background:#0067d2; width:100%; height:100%; ">
                            <span >{{ n11
                            }}</span>
                        </div>
                    </div>

                    <div id="n13" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:82.8%; top:46.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        
                        <div style="background:#fff; width:100%; height:100%; ">
                            <span >{{ n13 }}</span>
                        </div>
                    </div>

                    <div id="n25" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:32%; top:47.4%;">
                        <div style="border:2px solid #63b062; background:#63b062; width:100%; height:100%; ">
                            <span  >{{ n25
                            }}</span>
                        </div>
                    </div>

                    <div id="n26" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:31%;">
                        <div style="border:2px solid #63b062; background:#63b062; width:100%; height:100%; ">
                            <span  >{{ n26
                            }}</span>
                        </div>
                    </div>

                    <div id="n9" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:11.8%; top:46.1%;">
                    
                        <div style="border:2px solid #0067d2; background:#0067d2; width:100%; height:100%; ">
                            <span  >{{ n9
                            }}</span>
                        </div>
                    </div>

                    <div id="n18" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:26.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n18 }}</span>
                        </div>
                    </div>

                    <div id="n10" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:21.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n10 }}</span>
                        </div>
                    </div>

                    <div id="n20" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:68.8%; top:26.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n20 }}</span>
                        </div>
                    </div>

                    <div id="n12" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:72.5%; top:21.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span >{{ n12 }}</span>
                        </div>
                    </div>

                    <div id="n22" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:68.3%; top:67.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n22 }}</span>
                        </div>
                    </div>

                    <div id="n14" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:72%; top:71.7%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span  >{{ n14 }}</span>
                        </div>
                    </div>

                    <div id="n24" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:67.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n24 }}</span>
                        </div>
                    </div>

                    <div id="n16" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:71.4%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n16 }}</span>
                        </div>
                    </div>

                    <div id="n27" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:67%; top:55.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                             
                            <span style="">{{ n27 }}</span>
                        </div>
                    </div>

                    <div id="n32" class="trans  border-gray-800   "
                    style="position:absolute; width:5.5%; height:5.5%; left:61%; top:46.9%;  background:#Fff;    border:2px #000000  solid; ">
                    <div style=" width:100%; height:100%; box-shadow:1px 1px 20px #fff "><span
                            style=" "> {{ n32 }}
                        </span>
                    </div>
                </div>


                <div id="n31" class="trans  border-gray-800   "
                    style="position:absolute; width:6.5%; height:6.5%; left:54.3%; top:46.1%;  background:#Fff;  border:2px #000000  solid;   ">
                     
                    <div style=" width:100%; height:100%; box-shadow:1px 1px 20px #fff ">
                        <span style=" ">{{ n31
                            }}</span>
                    </div>
                </div>
    

                </div>

                <div  class="container mx-auto text-center pb-3 text-xl ">
                    <p> {{ name_2 }}<span v-if="age_2 != '' && name_2 != '' " >,</span> {{ age_2 }} <span v-if="age_2 != ''" >jahre alt</span></p>
                </div>
                <div class="obch w-full relative fade">
                    <img src="https://wordpresstuts.com.br/wp-content/uploads/2024/05/schemalittle.png" class="transimage">
                    <div id="n1" class="trans" style="position:absolute; width:9%; height:9%; left:1.4%; top:44.6%;"> 
                        <div style="border:2px solid #ae309a; background:#ae309a;width:100%; height:100%; ">
                            <span  >{{ n1_2
                            }}</span>
                        </div>
                    </div>

                    <div id="n3" class="trans" style="position:absolute; width:9%; height:9%; left:45.5%; top:1.4%;">
                        
                        <div style="border:2px solid #ae309a; background:#ae309a; width:100%; height:100%;  ">
                            <span  >{{ n3_2
                            }}</span>
                        </div>
                    </div>

                    <div id="n5" class="trans" style="position:absolute; width:9%; height:9%; left:89%; top:44.6%;">
                        
                        <div style="border:2px solid #eb4b41;background:#eb4b41; width:100%; height:100%;  ">
                            <span  >{{ n5_2
                            }}</span>
                        </div>
                    </div>

                    <div id="n7" class="trans" style="position:absolute; width:9%; height:9%; left:45.4%; top:89%;">
                        
                        <div style="border:2px solid #eb4b41;background:#eb4b41; width:100%; height:100%;  ">
                            <span  >{{ n7_2
                            }}</span>
                        </div>
                    </div>

                    <div id="n30" class="trans relative" style="position:absolute; width:9%; height:9%; left:45%; top:45%;">
                        
                        <div style="border:2px solid #ffde68;background:#ffde68; width:100%; height:100%;">
                            <span style=" ">{{
                                n30_2 }}</span>
                        </div>
                    </div>

                    <div id="n2" class="trans"
                        style="position:absolute; width:9%; height:9%; left:14.5%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n2_2 }}</span>
                        </div>
                    </div>

                    <div id="n4" class="trans"
                        style="position:absolute; width:9%; height:9%; left:76%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n4_2 }}</span>
                        </div>
                    </div>

                    <div id="n6" class="trans"
                        style="position:absolute; width:9%; height:9%; left:76%; top:75.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n6_2 }}</span>
                        </div>
                    </div>

                    <div id="n8" class="trans"
                        style="position:absolute; width:9%; height:9%; left:14.4%; top:75.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n8_2 }}</span>
                        </div>
                    </div>

                    <div id="n23" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:76.7%; ">
                        
                        <div style="border:2px solid #e98c46; background:#e98c46;width:100%; height:100%; ">
                            <span >{{ n23_2 }}</span>
                        </div>
                    </div>

                    <div id="n21" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:77%; top:47.4%;  ">
                        
                        <div style="border:2px solid #e98c46;background:#e98c46; width:100%; height:100%; ">
                            <span  >{{ n21_2 }}</span>
                        </div>
                    </div>

                    <div id="n28" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:61%; top:60.5%;  border:2px #000000  solid; background:#F0E4F7;">
                        
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n28_2 }}</span>
                        </div>
                    </div>

                    <div id="n29" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:55.5%; top:65.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n29_2 }}</span>
                        </div>
                    </div>

                    <div id="n17" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:18.3%; top:46.8%; ">
                        
                        <div style="border:2px solid #00b8f4; background:#00b8f4;width:100%; height:100%; ">
                            <span  >{{ n17_2 }}</span>
                        </div>
                    </div>

                    <div id="n19" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.4%; top:18%;">
                    
                        <div style="border:2px solid #00b8f4;background:#00b8f4; width:100%; height:100%; ">
                            <span  >{{ n19_2 }}</span>
                        </div>
                    </div>

                    <div id="n15" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:82%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n15_2 }}</span>
                        </div>
                    </div>

                    <div id="n11" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:11.4%; ">
                        
                        <div style="border:2px solid #0067d2;background:#0067d2; width:100%; height:100%; ">
                            <span  >{{ n11_2 }}</span>
                        </div>
                    </div>

                    <div id="n13" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:82.8%; top:46.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n13_2 }}</span>
                        </div>
                    </div>

                    <div id="n25" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:32%; top:47.4%;">
                        <div style="border:2px solid #63b062;background:#63b062; width:100%; height:100%; ">
                            <span  >{{ n25_2 }}</span>
                        </div>
                    </div>

                    <div id="n26" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:31%;">
                        <div style="border:2px solid #63b062;background:#63b062; width:100%; height:100%; ">
                            <span >{{ n26_2 }}</span>
                        </div>
                    </div>

                    <div id="n9" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:11.8%; top:46.1%;">
                    
                        <div style="border:2px solid #0067d2;background:#0067d2; width:100%; height:100%; ">
                            <span  >{{ n9_2 }}</span>
                        </div>
                    </div>

                    <div id="n18" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:26.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style=" ">{{ n18_2 }}</span>
                        </div>
                    </div>

                    <div id="n10" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:21.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n10_2 }}</span>
                        </div>
                    </div>

                    <div id="n20" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:68.8%; top:26.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n20_2 }}</span>
                        </div>
                    </div>

                    <div id="n12" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:72.5%; top:21.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n12_2 }}</span>
                        </div>
                    </div>

                    <div id="n22" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:68.3%; top:67.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n22_2 }}</span>
                        </div>
                    </div>

                    <div id="n14" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:72%; top:71.7%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n14_2 }}</span>
                        </div>
                    </div>

                    <div id="n24" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:67.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n24_2 }}</span>
                        </div>
                    </div>

                    <div id="n16" class="trans"
                        style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:71.4%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                            <span style="">{{ n16_2 }}</span>
                        </div>
                    </div>

                    <div id="n27" class="trans"
                        style="position:absolute; width:4.5%; height:4.5%; left:67%; top:55.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                        <div style="background:#Fff; width:100%; height:100%; ">
                           
                            <span style="">{{ n27_2 }}</span>
                        </div>
                    </div> 

                    <div id="n32" class="trans  border-gray-800   "
                    style="position:absolute; width:5.5%; height:5.5%; left:61%; top:46.9%;  background:#Fff; border:2px #000000  solid;   ">
                    <div style=" width:100%; height:100%; box-shadow:1px 1px 20px #fff "><span
                            style=" "> {{ n32_2 }}
                        </span>
                    </div>
                </div>


                <div id="n31" class="trans  border-gray-800   "
                    style="position:absolute; width:6.5%; height:6.5%; left:54.3%; top:46.1%;  background:#Fff;  border:2px #000000  solid;  ">
                    
                    <div style=" width:100%; height:100%; box-shadow:1px 1px 20px #fff ">
                        <span style=" ">{{ n31_2
                            }}</span>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="both w-full lg:w-1/2 px-5 lg:px-0 mt-16 lg:mt-0"  >
            <div class="obch w-full  relative fade">
               
                
                <div class="relative">
                    <img src="https://wordpresstuts.com.br/wp-content/uploads/2024/05/schemalittle.png" class="transimage">
                <div id="n1" class="trans" style="position:absolute; width:9%; height:9%; left:1.4%; top:44.6%;">
                    
                    <div style="border:2px solid #ae309a;background:#ae309a; width:100%; height:100%; ">
                        <span >{{ n1_3
                        }}</span>
                    </div>
                </div>

                <div id="n3" class="trans" style="position:absolute; width:9%; height:9%; left:45.5%; top:1.4%;">
                    
                    <div style="border:2px solid #ae309a;background:#ae309a; width:100%; height:100%;  ">
                        <span  >{{ n3_3
                        }}</span>
                    </div>
                </div>

                <div id="n5" class="trans" style="position:absolute; width:9%; height:9%; left:89%; top:44.6%;">
                     
                    <div style="border:2px solid #eb4b41;background:#eb4b41; width:100%; height:100%;  ">
                        <span  >{{ n5_3
                        }}</span>
                    </div>
                </div>

                <div id="n7" class="trans" style="position:absolute; width:9%; height:9%; left:45.4%; top:89%;">
                     
                    <div style="border:2px solid #eb4b41;background:#eb4b41; width:100%; height:100%;  ">
                        <span >{{ n7_3
                        }}</span>
                    </div>
                </div>

                <div id="n30" class="trans relative" style="position:absolute; width:9%; height:9%; left:45%; top:45%;">
                     
                    <div style="border:2px solid #ffde68;background:#ffde68; width:100%; height:100%;">
                        <span style=" ">{{
                            n30_3 }}</span>
                    </div>
                </div>

                <div id="n2" class="trans"
                    style="position:absolute; width:9%; height:9%; left:14.5%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n2_3 }}</span>
                    </div>
                </div>

                <div id="n4" class="trans"
                    style="position:absolute; width:9%; height:9%; left:76%; top:14%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n4_3 }}</span>
                    </div>
                </div>

                <div id="n6" class="trans"
                    style="position:absolute; width:9%; height:9%; left:76%; top:75.9%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n6_3 }}</span>
                    </div>
                </div>

                <div id="n8" class="trans"
                    style="position:absolute; width:9%; height:9%; left:14.4%; top:75.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n8_3 }}</span>
                    </div>
                </div>

                <div id="n23" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:76.7%; ">
                     
                    <div style="border:2px solid #e98c46;background:#e98c46; width:100%; height:100%; ">
                        <span  >{{ n15_3
                        }}</span>
                    </div>
                </div>

                <div id="n21" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:77%; top:47.4%;  ">
                     
                    <div style="border:2px solid #e98c46;background:#e98c46; width:100%; height:100%; ">
                        <span >{{ n21_3
                        }}</span>
                    </div>
                </div>

                <div id="n28" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:61.3%; top:61%;  border:2px #000000  solid; background:#F0E4F7;">
                     
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n28_3 }}</span>
                    </div>
                </div>

                <div id="n29" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:55.5%; top:66.6%;  border:2px #000000  solid; background:#F0E4F7;   ">
                     
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n29_3 }}</span>
                    </div>
                </div>

                <div id="n17" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:18.3%; top:46.8%; ">
                     
                    <div style="border:2px solid #00b8f4; background:#00b8f4; width:100%; height:100%; ">
                        <span  >{{ n17_3
                        }}</span>
                    </div>
                </div>

                <div id="n19" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.4%; top:18%;">
                   
                    <div style="border:2px solid #00b8f4;background:#00b8f4; width:100%; height:100%; ">
                        <span >{{ n19_3
                        }}</span>
                    </div>
                </div>

                <div id="n15" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:82%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n23_3 }}</span>
                    </div>
                </div>

                <div id="n11" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:11.4%; ">
                     
                    <div style="border:2px solid #0067d2;background:#0067d2; width:100%; height:100%; ">
                        <span >{{ n11_3
                        }}</span>
                    </div>
                </div>

                <div id="n13" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:82.8%; top:46.5%;  border:2px #000000  solid; background:#F0E4F7;   ">
                     
                    <div style="background:#Fff; width:100%; height:100%; ">
                        <span style=" ">{{ n13_3 }}</span>
                    </div>
                </div>
 
 

                <div id="n9" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:11.8%; top:46.1%;">
                  
                    <div style="border:2px solid #0067d2; background:#0067d2; width:100%; height:100%; ">
                        <span  >{{ n9_3
                        }}</span>
                    </div>
                </div>
  

                <div id="n27" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:67%; top:55.2%;  border:2px #000000  solid; background:#F0E4F7;   ">
                    <div style="background:#Fff; width:100%; height:100%; ">
                         
                        <span style="">{{ n27_3 }}</span>
                    </div>
                </div>
                 </div>

            <div class="added">

 

 

 

 

 

 

 
</div>

</div> 
            </div>
        </div>

<div class="flex flex-wrap mt-12 w-ful px-4 items-stratch justify-between lg:px-1" >

    <div class="flex flex-col gap-6 w-full lg:w-1/3 justify-between text-sm explanation-item" >

            
                    <!---->
                    <div class="flex items-center flex-col ">
        <div class="rounded-full py-3 px-4" style="font-size:17px;   margin-bottom:5px; ">Beziehung
        </div>
        <p style="font-size:13px;" class="text-center">Suche nach finanzieller Stabilität. Umsetzung gemeinsamer Ziele. Spirituelles Wachstum.</p>
        <div class="flex justify-center gap-2.5 items-center mt-6">
        <div>
            <div class="flex items-center justify-between gap-2.5">
                <p>Himmel</p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n60">{{ n57 }}</span>
            </div>
            <div class="flex items-center justify-between gap-2.5">
                <p>Erde</p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n62">{{ n59 }}</span>
            </div>
        </div>
        <img src="https://deine-schicksalsmatrix.de/wp-content/uploads/2024/07/curlybraces.png" style="height:80px" alt="curly" />
        <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n61">{{ n58 }}</div>
    </div>
                    <!---->
                </div>              
    </div>

    <div class="flex flex-col gap-0  justify-between  w-full lg:w-1/3 text-sm explanation-item">
        
        <!---->
        <div class="flex items-center flex-col ">
        <div class="rounded-full py-3 px-4" style="font-size:17px;   margin-bottom:5px; ">Verschmelzung 
        </div>
        <p style="font-size:13px;" class="text-center">Finanzielles Potenzial, Bewältigung der Ahnenaufgaben, Vereinigung zweier Ahnenreihen. Gesellschaftliche Realisation.</p>
        <div class="flex justify-center gap-2.5 items-center mt-6">
        <div>
            <div class="flex items-center justify-between gap-2.5">
                <p>M</p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n60">{{ n60 }}</span>
            </div>
            <div class="flex items-center justify-between gap-2.5">
                <p>W</p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n62">{{ n62 }}</span>
            </div>
        </div>
        <img src="https://deine-schicksalsmatrix.de/wp-content/uploads/2024/07/curlybraces.png" style="height:80px" alt="curly" />
        <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n61">{{ n61 }}</div>
    </div>

        <!---->
        
        </div>
    </div>

    <div class="flex flex-col gap-0  justify-between  w-full lg:w-1/3 text-sm explanation-item">   

        <!---->
        <div class="flex items-center flex-col ">
        <div class="rounded-full py-3 px-4" style="font-size:17px;   margin-bottom:5px; ">Harmonie</div>
        <p style="font-size:13px;" class="text-center">Phase einer Beziehung, in der die Partner die Persönlichkeit des anderen respektieren und sich vollkommen einig fühlen.</p>
        <div class="flex justify-center gap-2.5 items-center mt-6">
        <div>
            <div class="flex items-center justify-between gap-2.5">
                <p> </p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n58">{{ n58 }}</span>
            </div>
            <div class="flex items-center justify-between gap-2.5">
                <p> </p>
                <span class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n61">{{ n61 }}</span>
            </div>
        </div>
        <img src="https://deine-schicksalsmatrix.de/wp-content/uploads/2024/07/curlybraces.png" style="height:80px" alt="curly" />
        <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center" id="n63">{{ n63 }}</div>
    </div>

        <!---->
    </div>

</div>
 
</div>

    </section>
</template>

<script>


export default {

    data() {
        return {
            M:0,
            K:0,
            L:0,
            N:0,
            P:0,
            O:0,
            R:0,
            name: '',
            name_2: '',
            age: '',
            age_2: '',
            date: '---------',
            date_2: '---------',
            resultDay: 0,
            resultMonth: 0,
            resultYear: 0,

            resultDay_2: 0,
            resultMonth_2: 0,
            resultYear_2: 0,
           
             
            result: '',
            isRestult: false,
            showResult: false,
            values: 0,
            day: 2,
            day_2: 2,
            month: 4,
            month_2: 4,
            year: 1981,
            year_2: 1981,
            n1: 0,
            n1_2: 0,
            n1_3: 0,
            n3: 0,
            n3_2: 0,
            n3_3: 0,
            n5: 0,
            n5_2:0,
            n5_3:0,
            n2: 0,
            n2_2: 0,
            n2_3: 0,
            n4: 0,
            n4_2: 0,
            n4_3: 0,
            n6: 0,
            n6_2: 0,
            n6_3: 0,
            n7: 0,
            n7_2: 0,
            n7_3: 0,
            n8: 0,
            n8_2: 0,
            n8_3: 0,
            n9: 0,
            n9_2: 0,
            n9_3: 0,
            n10: 0,
            n10_2: 0,
            n10_3: 0,
            n11: 0,
            n11_2: 0,
            n11_3: 0,
            n12: 0,
            n12_2: 0,
            n12_3: 0,
            n13: 0,
            n13_2: 0,
            n13_3: 0,
            n14: 0,
            n14_2: 0,
            n14_3: 0,
            n15: 0,
            n15_2: 0,
            n15_3: 0,
            n16: 0,
            n16_2: 0,
            n16_3: 0,
            n17: 0,
            n17_2: 0,
            n17_3: 0,
            n18: 0,
            n18_2: 0,
            n18_3: 0,
            n19: 0,
            n19_2: 0,
            n19_3: 0,
            n20: 0,
            n20_2: 0,
            n20_3: 0,
            n21: 0,
            n21_2: 0,
            n21_3: 0,
            n22: 0,
            n22_2: 0,
            n22_3: 0,
            n23: 0,
            n23_2: 0,
            n23_3: 0,
            n24: 0,
            n24_2: 0,
            n24_3: 0,
            n25: 0,
            n25_2: 0,
            n25_3: 0,
            n26: 0,
            n26_2: 0,
            n26_3: 0,
            n27: 0,
            n27_2: 0,
            n27_3: 0,
            n28: 0,
            n28_2: 0,
            n28_3: 0,
            n29: 0,
            n29_2: 0,
            n29_3: 0,
            n30: 0,
            n30_2: 0,
            n30_3: 0,
            n31: 0,
            n31_2: 0,
            n31_3: 0,
            n32: 0,
            n32_2: 0,
            n32_3: 0,
            
            n33: 0,
            n34: 0,
            n35: 0,
            n36: 0,
            n37: 0,
            n38: 0,
            n39: 0,
            n40: 0,
            n41: 0,
            n42: 0,
            n43: 0,
            n44: 0,
            n45: 0,
            n46: 0,
            n47: 0,
            n48: 0,
            n49: 0,
            n50: 0,
            n51: 0,
            n52: 0,
            n53: 0,
            n54: 0,
            n55: 0,
            n56: 0,
            n57: 0,
            n58: 0,
            n59: 0,
            n60: 0,
            n61: 0,
            n62: 0,
            n63: 0,

            
            
        }
    },
    methods: {

    IfIsMoreThan22(value) {
            if (value > 22) {
                this.values = value.toString().split('').map(Number);
                value = this.values.reduce((a, b) => b + a);

                if (value < 22) {
                    return value;
                } else {

                    if(value == 22){
                        return value
                    }else {
                        this.values = value.toString().split('').map(Number);
                    value = this.values.reduce((a, b) => b + a);
                    return value;
                    }
                   
                }

            } else {
                return value;
            }
        },
        TheN1() {
            this.resultDay = this.date.split('-');
            this.day = parseInt(this.resultDay[2]);
            this.n1 = this.IfIsMoreThan22(this.day);
        },

        TheN5() {
            this.resultYear = this.date.split('-');
            this.year = parseInt(this.resultYear[0]);
            this.n5 = this.IfIsMoreThan22(this.year);
        },

        TheN3() {
            this.resultMonth = this.date.split('-');
            this.month = parseInt(this.resultMonth[1]);
            this.n3 = this.IfIsMoreThan22(this.month);
        },

        TheN7() {
            this.n7 = this.IfIsMoreThan22(this.n1 + this.n5 + this.n3);
        },

        TheD() {
            this.n30 = this.IfIsMoreThan22(this.n1 + this.n5 + this.n3 + this.n7);
        },
        TheN17() {

            this.n17 = this.IfIsMoreThan22(this.n30 + this.n1);
        },
        TheN19() {
            this.n19 = this.IfIsMoreThan22(this.n3 + this.n30);
        },

        TheN21() {
            this.n21 = this.IfIsMoreThan22(this.n5 + this.n30);
        },

        TheN23() {
            this.n23 = this.IfIsMoreThan22(this.n7 + this.n30);
        },

        TheN9() {
            this.n9 = this.IfIsMoreThan22(this.n1 + this.n17);
        },

        TheN11() {
            this.n11 = this.IfIsMoreThan22(this.n19 + this.n3);
        },
        TheN13() {
            this.n13 = this.IfIsMoreThan22(this.n5 + this.n21);
        },

        TheN15() {
            this.n15 = this.IfIsMoreThan22(this.n7 + this.n23);
        },

        TheN2() {
            this.n2 = this.IfIsMoreThan22(this.n1 + this.n3);
        },

        TheN4() {
            this.n4 = this.IfIsMoreThan22(this.n5 + this.n3);
        },

        TheN6() {
            this.n6 = this.IfIsMoreThan22(this.n5 + this.n7);
        },

        TheN8() {
            this.n8 = this.IfIsMoreThan22(this.n1 + this.n7);
        },

        TheN31() {
            this.n31 = this.IfIsMoreThan22(this.n2 + this.n4 + this.n6 + this.n8);
        },

        TheN18() {
            this.n18 = this.IfIsMoreThan22(this.n2 + this.n31);
        },


        TheN20() {
            this.n20 = this.IfIsMoreThan22(this.n4 + this.n31);
        },

        TheN22() {
            this.n22 = this.IfIsMoreThan22(this.n6 + this.n31);
        },

        TheN24() {
            this.n24 = this.IfIsMoreThan22(this.n8 + this.n31);
        },

        TheN10() {
            this.n10 = this.IfIsMoreThan22(this.n2 + this.n18);
        },

        TheN12() {
            this.n12 = this.IfIsMoreThan22(this.n4 + this.n20);
        },

        TheN14() {
            this.n14 = this.IfIsMoreThan22(this.n6 + this.n22);
        },

        TheN16() {
            this.n16 = this.IfIsMoreThan22(this.n8 + this.n24);
        },

        TheN26() {
            this.n26 = this.IfIsMoreThan22(this.n19 + this.n30);
        },

        TheN25() {
            this.n25 = this.IfIsMoreThan22(this.n17 + this.n30);
        },

        TheN28() {
            this.n28 = this.IfIsMoreThan22(this.n23 + this.n21);
        },

        TheN27() {
            this.n27 = this.IfIsMoreThan22(this.n28 + this.n21);
        },

        TheN29() {
            this.n29 = this.IfIsMoreThan22(this.n28 + this.n23);
        },

        // TheN31() {
        //     this.n31 = this.IfIsMoreThan22(this.n2 + this.n4 + this.n6 + this.n8);
        // },

        TheN32() {
            this.n32 = this.IfIsMoreThan22(this.n30 + this.n31);
        },

        

        TheN33() {
            this.n33 = this.n1;
        },

        TheN34() {
            this.n34 = this.n3;
        },

        TheN35() {
            this.n35 = this.IfIsMoreThan22(this.n3 + this.n1);
        },

        TheN36() {
            this.n36 = this.n9;
        },

        TheN37() {
            this.n37 = this.n11;
        },

        TheN38() {
            this.n38 = this.IfIsMoreThan22(this.n9 + this.n11);
        },

        TheN39() {
            this.n39 = this.n17;
        },

        TheN40() {
            this.n40 = this.n19;
        },

        TheN41() {
            this.n41 = this.IfIsMoreThan22(this.n19 + this.n17);
        },

        TheN42() {
            this.n42 = this.n25;
        },

        TheN43() {
            this.n43 = this.n26;
        },

        TheN44() {
            this.n44 = this.IfIsMoreThan22(this.n26 + this.n25);
        },

      

        TheN48() {
            this.n48 = this.n21;
        },

        TheN49() {
            this.n49 = this.n23;
        },

      

        TheN1_2() {
            this.resultDay_2 = this.date_2.split('-');
            this.day_2 = parseInt(this.resultDay_2[2]);
            this.n1_2 = this.IfIsMoreThan22(this.day_2);
        },

        TheN5_2() {
            this.resultYear_2 = this.date_2.split('-');
            this.year_2 = parseInt(this.resultYear_2[0]);
            this.n5_2 = this.IfIsMoreThan22(this.year_2);
        },

        TheN3_2() {
            this.resultMonth_2 = this.date_2.split('-');
            this.month_2 = parseInt(this.resultMonth_2[1]);
            this.n3_2 = this.IfIsMoreThan22(this.month_2);
        },

        TheN7_2() {
            this.n7_2 = this.IfIsMoreThan22(this.n1_2 + this.n5_2 + this.n3_2);
        },

        TheD_2() {
            this.n30_2 = this.IfIsMoreThan22(this.n1_2 + this.n5_2 + this.n3_2 + this.n7_2);
        },
        TheN17_2() {

            this.n17_2 = this.IfIsMoreThan22(this.n30_2 + this.n1_2);
        },
        TheN19_2() {
            this.n19_2 = this.IfIsMoreThan22(this.n3_2 + this.n30_2);
        },

        TheN21_2() {
            this.n21_2 = this.IfIsMoreThan22(this.n5_2 + this.n30_2);
        },

        TheN23_2() {
            this.n23_2 = this.IfIsMoreThan22(this.n7_2 + this.n30_2);
        },

        TheN9_2() {
            this.n9_2 = this.IfIsMoreThan22(this.n1_2 + this.n17_2);
        },

        TheN11_2() {
            this.n11_2 = this.IfIsMoreThan22(this.n19_2 + this.n3_2);
        },
        TheN13_2() {
            this.n13_2 = this.IfIsMoreThan22(this.n5_2 + this.n21_2);
        },

        TheN15_2() {
            this.n15_2 = this.IfIsMoreThan22(this.n7_2 + this.n23_2);
        },

        TheN2_2() {
            this.n2_2 = this.IfIsMoreThan22(this.n1_2 + this.n3_2);
        },

        TheN4_2() {
            this.n4_2 = this.IfIsMoreThan22(this.n5_2 + this.n3_2);
        },

        TheN6_2() {
            this.n6_2 = this.IfIsMoreThan22(this.n5_2 + this.n7_2);
        },

        TheN8_2() {
            this.n8_2 = this.IfIsMoreThan22(this.n1_2 + this.n7_2);
        },

        TheN31_2() {
            this.n31_2 = this.IfIsMoreThan22(this.n2_2 + this.n4_2 + this.n6_2 + this.n8_2);
        },

        TheN18_2() {
            this.n18_2 = this.IfIsMoreThan22(this.n2_2 + this.n31_2);
        },

        TheN20_2() {
            this.n20_2 = this.IfIsMoreThan22(this.n4_2 + this.n31_2);
        },

        TheN22_2() {
            this.n22_2 = this.IfIsMoreThan22(this.n6_2 + this.n31_2);
        },

        TheN24_2() {
            this.n24_2 = this.IfIsMoreThan22(this.n8_2 + this.n31_2);
        },

        TheN10_2() {
            this.n10_2 = this.IfIsMoreThan22(this.n2_2 + this.n18_2);
        },

        TheN12_2() {
            this.n12_2 = this.IfIsMoreThan22(this.n4_2 + this.n20_2);
        },

        TheN14_2() {
            this.n14_2 = this.IfIsMoreThan22(this.n6_2 + this.n22_2);
        },

        TheN16_2() {
            this.n16_2 = this.IfIsMoreThan22(this.n8_2 + this.n24_2);
        },

        TheN26_2() {
            this.n26_2 = this.IfIsMoreThan22(this.n19_2 + this.n30_2);
        },

        TheN25_2() {
            this.n25_2 = this.IfIsMoreThan22(this.n17_2 + this.n30_2);
        },

        TheN28_2() {
            this.n28_2 = this.IfIsMoreThan22(this.n23_2 + this.n21_2);
        },

        TheN27_2() {
            this.n27_2 = this.IfIsMoreThan22(this.n28_2 + this.n21_2);
        },

        TheN29_2() {
            this.n29_2 = this.IfIsMoreThan22(this.n28_2 + this.n23_2);
        },

      

        TheN32_2() {
            this.n32_2 = this.IfIsMoreThan22(this.n30_2 + this.n31_2);
        },

        TheN45() {
            this.n45 = this.n30_3;
        },

        TheN46() {
            this.n46 = this.n30_3;
        },

        TheN47() {
            this.n47 = this.IfIsMoreThan22(this.n30_3 + this.n30_3);
        },

        TheN50() {
            this.n50 = this.IfIsMoreThan22(this.n21_3 + this.n23_3);
        },

        TheN51() {
            this.n51 = this.n5_3;
        },

        TheN52() {
            this.n52 = this.n7_3;
        },

        TheN53() {
            this.n53 = this.IfIsMoreThan22(this.n5_3 + this.n7_3);
        },

        TheN54() {
            this.n54 = this.IfIsMoreThan22(this.n1 + this.n9 + this.n17 + this.n25 + this.n30 + this.n21 + this.n5);
        },

        TheN55() {
            this.n55 = this.IfIsMoreThan22(this.n3 + this.n11 + this.n19 + this.n26 + this.n30 + this.n23 + this.n7);
        },

        TheN56() {
            this.n56 = this.IfIsMoreThan22(this.n35 + this.n38 + this.n41 + this.n44 +  this.n47  + this.n50 + this.n53 );
        },

        TheN57() {
            this.n57 = this.IfIsMoreThan22(this.n3_3 + this.n7_3);
        },


        TheN59() {
            this.n59 = this.IfIsMoreThan22(this.n1_3 + this.n5_3);
        },

        TheN58() {
            this.n58 = this.IfIsMoreThan22(this.n59 + this.n57);
        },


        TheN60() {
            this.n60 = this.IfIsMoreThan22(this.n2_3 + this.n6_3);
        },


        TheN62() {
            this.n62 = this.IfIsMoreThan22(this.n4_3 + this.n8_3);
        },

        TheN61() {
            this.n61 = this.IfIsMoreThan22(this.n60 + this.n62);
        },


        TheN63() {
            this.n63 = this.IfIsMoreThan22(this.n58 + this.n61);
        },

        TheL(){
            this.L = this.IfIsMoreThan22(this.n1_3 + this.n5_3);
        },

        TheM(){
            this.M = this.IfIsMoreThan22(this.n3_3 + this.n7_3);
        },

        TheK(){
            this.K = this.IfIsMoreThan22(this.M + this.L);
        },

        TheO(){
            this.O = this.IfIsMoreThan22(this.n2_3 + this.n6_3);
        },

        TheP(){
            this.P = this.IfIsMoreThan22(this.n4_3 + this.n8_3);
        },

        TheN(){
            this.N = this.IfIsMoreThan22(this.O + this.P);
        },

        TheR(){
            this.R = this.IfIsMoreThan22(this.K + this.N);
        },






        TheBoth(){
          this.n1_3 = this.IfIsMoreThan22(this.n1 + this.n1_2);
          this.n2_3 = this.IfIsMoreThan22(this.n2 + this.n2_2);          
          this.n3_3 = this.IfIsMoreThan22(this.n3 + this.n3_2);
          this.n4_3 = this.IfIsMoreThan22(this.n4 + this.n4_2);
          this.n5_3 = this.IfIsMoreThan22(this.n5 + this.n5_2);
          this.n6_3 = this.IfIsMoreThan22(this.n6 + this.n6_2);
          this.n7_3 = this.IfIsMoreThan22(this.n7 + this.n7_2);     
          this.n8_3 = this.IfIsMoreThan22(this.n8 + this.n8_2);
          this.n30_3 = this.IfIsMoreThan22(this.n30 + this.n30_2); 
          this.n17_3 = this.IfIsMoreThan22(this.n1_3 + this.n30_3);
          this.n9_3 = this.IfIsMoreThan22(this.n17_3 + this.n1_3);
          this.n19_3 = this.IfIsMoreThan22(this.n3_3 + this.n30_3);
          this.n11_3 = this.IfIsMoreThan22(this.n19_3 + this.n3_3);  
          this.n21_3 = this.IfIsMoreThan22(this.n5_3 + this.n30_3);
          this.n13_3 = this.IfIsMoreThan22(this.n21_3 + this.n5_3);  
          this.n15_3 = this.IfIsMoreThan22(this.n7_3 + this.n30_3); 
          this.n23_3 = this.IfIsMoreThan22(this.n15_3 + this.n7_3);   
          this.n28_3 = this.IfIsMoreThan22(this.n21_3 + this.n15_3); 
          this.n29_3 = this.IfIsMoreThan22(this.n28_3 + this.n15_3); 
          this.n27_3 = this.IfIsMoreThan22(this.n21_3 + this.n28_3);

          

        },


Age(){
    var today = new Date();
    var birthDate = new Date(this.date);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    this.age = age;
},

Age_2(){
    var today = new Date();
    var birthDate = new Date(this.date_2);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    this.age_2 = age;
},

Calculat() {   

    if(this.date !== '---------' && this.date_2 !== '---------'){
            this.isRestult = true;
            this.showResult = true;
            this.TheN1();
            this.TheN5();
            this.TheN3();
            this.TheN7();
            this.TheD();
            this.TheN17();
            this.TheN19();
            this.TheN41();
            this.TheN21();
            this.TheN23();
            this.TheN9();
            this.TheN11();
            this.TheN13();
            this.TheN2();
            this.TheN15();
            this.TheN4();
            this.TheN6();
            this.TheN8();
            this.TheN31();
            this.TheN18();
            this.TheN20();
            this.TheN22();
            this.TheN24();
            this.TheN10();
            this.TheN12();
            this.TheN14();
            this.TheN16();
            this.TheN26();
            this.TheN25();
            this.TheN28();
            this.TheN27();
            this.TheN29(); 
          
            this.TheN32();
            this.TheN33();
            this.TheN34();
            this.TheN35();
            this.TheN36();
            this.TheN37();
            this.TheN38();
            this.TheN39();
            this.TheN40();
            this.TheN41();
            this.TheN42();
            this.TheN43();
            this.TheN44();
            this.TheN45();
            this.TheN46();
            this.TheN47();
            this.TheN48();
            this.TheN49();
            
            this.Age();

            this.TheN1_2();
            this.TheN5_2();
            this.TheN3_2();
            this.TheN7_2();
            this.TheD_2();
            this.TheN17_2();
            this.TheN19_2();
             
            this.TheN21_2();
            this.TheN23_2();
            this.TheN9_2();
            this.TheN11_2();
            this.TheN13_2();
            this.TheN2_2();
            this.TheN15_2();
            this.TheN4_2();
            this.TheN6_2();
            this.TheN8_2();
            this.TheN31_2();
            this.TheN18_2();
            this.TheN20_2();
            this.TheN22_2();
            this.TheN24_2();
            this.TheN10_2();
            this.TheN12_2();
            this.TheN14_2();
            this.TheN16_2();
            this.TheN26_2();
            this.TheN25_2();
            this.TheN28_2();
            this.TheN27_2();
            this.TheN29_2();
           
            this.TheN32_2();
            this.TheBoth();
            this.TheN50();
            this.TheN51();
            this.TheN52();
            this.TheN53();
            this.TheN54();
            this.TheN55();
            this.TheN56();
            this.TheN57();
            this.TheN59();
            this.TheN58();
            this.TheN60();
            this.TheN62();
            this.TheN61();
            this.TheN63();
            this.Age_2();
            this.TheL();
            this.TheM();
            this.TheK();
            this.TheO();
            this.TheP();
            this.TheN();
            this.TheR();
    }else {
        alert('Por favor, indique ambas fechas de nacimiento');
    }
     
    
   
},
 

},
    beforeMount() {
      // this.Calculat();
    },
     
}
</script>

<style scoped>
.resultItem {
    background: #fafbfc;
}

.sectionopener items-center span {
    font-size: 24px;
    font-weight: bold;
}

.info {
    border-radius: 8px;
    top: -45px;
    left: 50%;
    transform: translate(-50%);
    display: none;
    z-index: 1000;
    transition: 300ms;
    background: #E9F0F7;
    border: 2px solid;
}

.info:after {
    z-index: 99;
    content: '';
    display: block;
    position: absolute;
    width: 15px;
    height: 15px;
    background: #E9F0F7;
    transform: rotate(-45deg) translateX(-50%);
    bottom: -3px;
    left: 50%;
    transition: 300ms;
    border-bottom: 1px solid;
    border-left: 1px solid;
}
 
 

div,
p,
span {
    font-family: 'Lato', sans-serif;
}

.transimage {
    bottom: 2px !important;
    right: 1px !important;
}


select {
    background-color: #fff !important;
    border-radius: 26px !Important;
}

@media screen and (max-width:1200px) {
    .obch {
        flex: 0 0 100% !important;
        padding: 10px;
    }

    .transimage {
        bottom: 5px !important;
    }

}


#formMatrix h3 {
    text-align: center;
}


.obch .trans,
.obch .trans>div {
    border-radius: 50%;
    display:flex;
    justify-content:center;
    align-items:center;
}

.obch .trans span{
    display:flex;
    justify-content:center;
    align-items:center;
}

.container {
    width: 1280px;
    max-width: 100%;
    margin: 0 auto;
}

.birthdate {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
     
    justify-content: center;
}

.birthdate-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.transimage {
    width: 101%;
    z-index: 0;
    position: relative;
   
}

.result p {
    margin-bottom: 18px;
}

.trans span {
    font-size: 13px;
}

@media screen and (max-width:1335px) {
    .trans span {
        font-size: 12px;
    }

    .container {
    width: 1280px;
    max-width: 100%;
    margin: 0 auto;
    }
 

    body {
        font-size:12px !important
    }
}
 
@media screen and (max-width:1200px) {
    .obch {
        flex: 0 0 100%;
        padding: 2px;
    }

    .rightblock {
        flex: 0 0 100%;
    }

    .trans span {
        font-size: 14px;
    }

    

}

#n1 span,
#n3 span,
#n5 span,
#n7 span,
#n30 span,
#n2 span,
#n4 span,
#n6 span,
#n8 span {
    font-size: 20px
}

@media screen and (max-width:600px) {
    .chakras>div {
        padding-left: 20px;
    }

    .trans span {
        font-size: 12px;
        position: relative;
        
    }

    .obch .trans span {
        font-size: 9px;
        
    }

    td {
        font-size:13px !important;
    }

    #n1 span,
    #n3 span,
    #n5 span,
    #n7 span,
    #n30 span,
    #n2 span,
    #n4 span,
    #n6 span,
    #n8 span {
        font-size: 16px;
        position: relative;
        bottom: 1px;
    }

    .transimage {
        width: 100%;
        z-index: 0;
        position: relative;
        bottom: 0 !important;
        right: 1px;
    }

    table {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        margin: 0 auto;
    }

}

@media screen and (max-width:470px) {

    .obch .trans span {
        font-size: 9px;
       

    }

}</style>
